import { createAction, props } from '@ngrx/store';
import { IShareholder } from '@appShared/interfaces/[Model-based]/shareholder.interface';

const apiLevelEventPrefix = '[Admin API]';

export const loadShareholderSuccess = createAction(
  `${apiLevelEventPrefix} Load Selected Shareholder Success`,
  props<{ shareholder: IShareholder }>()
);

export const loadShareholderFailure = createAction(
  `${apiLevelEventPrefix} Load Selected Shareholder Failure`,
  props<{ error: string }>()
);
